const checkPolicyResources = {
  en: {
    checkPolicy: {
      title: 'Check the policy',
      description:
        'Check the availability of an insurance policy at JSC "Insurance Company "Alatau City Garant"',
      type: 'Type of insurance',
      tab1: 'By a unique number',
      tab2: 'By IIN/BIN',
      policyNumber: 'Unique policy number',
      iin: 'IIN/BIN',
      carNumber: 'Vehicle State number',
      search: 'Search',
      result: 'Search result:',
      unique: 'Unique number',
      period: 'Validity period',
      number: 'Vehicle number',
      'Также вы можете проверить полис следующим образом:':
        'Также вы можете проверить полис следующим образом:',
      'Нажмите кнопку «Проверка полиса на сайте ГКБ»':
        'Нажмите кнопку «Проверка полиса на сайте ГКБ»',
      'Далее вы будете перенаправлены на официальный сайт Государственного кредитного бюро, которое является оператором "Единой страховой базы данных" и отвечает за хранение и актуализацию информации по полисам':
        'Далее вы будете перенаправлены на официальный сайт Государственного кредитного бюро, которое является оператором "Единой страховой базы данных" и отвечает за хранение и актуализацию информации по полисам',
      'Вам будет предложено выбрать класс страхования, и ввести соответсвующие параметры для поиска. К примеру, для поиска договора (полиса) страхования, выезжающего за рубеж, вам необходимо выбрать класс страхования "Договор добровольного страхования" и ввести 12-значный уникальный номер, который указан в договоре (полисе)':
        'Вам будет предложено выбрать класс страхования, и ввести соответсвующие параметры для поиска. К примеру, для поиска договора (полиса) страхования, выезжающего за рубеж, вам необходимо выбрать класс страхования "Договор добровольного страхования" и ввести 12-значный уникальный номер, который указан в договоре (полисе)',
      'Нажмите на кнопку "Проверить полис" и получите информацию о статусе полиса':
        'Нажмите на кнопку "Проверить полис" и получите информацию о статусе полиса',
      'Проверка полиса на сайте ГКБ': 'Проверка полиса на сайте ГКБ',
      'Чат-бот Telegram от ГКБ': 'Чат-бот Telegram от ГКБ',
      'Как узнать статус вашего договора (полиса) в личном кабинете?':
        'Как узнать статус вашего договора (полиса) в личном кабинете?',
      'Войдите в личный кабинет. Для этого введите свой ИНН и пароль, которые вы использовали при регистрации':
        'Войдите в личный кабинет. Для этого введите свой ИНН и пароль, которые вы использовали при регистрации',
      'Перейдите в раздел "Мои полисы", в этом разделе вы найдете список всех ваших активных и завершенных договоров страхования.':
        'Перейдите в раздел "Мои полисы", в этом разделе вы найдете список всех ваших активных и завершенных договоров страхования.',
      'Нажмите на нужный договор (полис), чтобы увидеть его подробности, включая текущий статус и сроки действия':
        'Нажмите на нужный договор (полис), чтобы увидеть его подробности, включая текущий статус и сроки действия',
      'Если у вас возникли вопросы или проблемы с доступом, не стесняйтесь обратиться в нашу службу поддержки по номеру 3264':
        'Если у вас возникли вопросы или проблемы с доступом, не стесняйтесь обратиться в нашу службу поддержки по номеру 3264',
    },
  },
  kz: {
    checkPolicy: {
      title: 'Полисті тексеру',
      description:
        '«Alatau City Garant» Сақтандыру компаниясы» АҚ-да сақтандыру полисін тексеру',
      type: 'Сақтандыру түрі',
      tab1: 'Бірегей нөмір бойынша',
      tab2: 'ЖСН/БСН бойынша',
      policyNumber: 'Бірегей полис нөмірі',
      iin: 'ЖСН/БСН',
      carNumber: 'Көлік нөмірі',
      search: 'Іздеу',
      result: 'Іздеу нәтижесі:',
      unique: 'Полис нөмірі',
      period: 'Жарамдылық мерзімі',
      number: 'Көлік нөмірі',
      'Также вы можете проверить полис следующим образом:':
        'Сондай-ақ, полисті келесідей тәсілмен тексеруге болады:',
      'Нажмите кнопку «Проверка полиса на сайте ГКБ»':
        '«МКБ сайтындағы полисті тексеру» түймесін басыңыз',
      'Далее вы будете перенаправлены на официальный сайт Государственного кредитного бюро, которое является оператором "Единой страховой базы данных" и отвечает за хранение и актуализацию информации по полисам':
        'Әрі қарай Сіз «Бірыңғай сақтандыру деректер базасының» операторы болып табылатын және полистер бойынша ақпаратты сақтауға және өзектендіруге жауапты Мемлекеттік кредиттік бюроның ресми сайтына қайта бағытталасыз',
      'Вам будет предложено выбрать класс страхования, и ввести соответсвующие параметры для поиска. К примеру, для поиска договора (полиса) страхования, выезжающего за рубеж, вам необходимо выбрать класс страхования "Договор добровольного страхования" и ввести 12-значный уникальный номер, который указан в договоре (полисе)':
        'Сізден сақтандыру сыныбын таңдау және іздеу үшін тиісті параметрлерді енгізу сұралады. Мысалы, шетелге шығушыларды сақтандыру шартын (полисін) іздеу үшін Сізге «Ерікті сақтандыру шарты» сақтандыру сыныбын таңдап, шартта (полисте) көрсетілген 12 таңбалы бірегей нөмірді енгізу қажет.',
      'Нажмите на кнопку "Проверить полис" и получите информацию о статусе полиса':
        '«Полисті тексеру» түймесін басып, полистің күйі туралы ақпарат алыңыз',
      'Проверка полиса на сайте ГКБ': 'МКБ сайтында полисті тексеру.',
      'Чат-бот Telegram от ГКБ': 'МКБ Telegram чат-боты',

      'Как узнать статус вашего договора (полиса) в личном кабинете?':
        'Жеке кабинетте шарттың (полистің) мәртебесін қалай білуге болады?',
      'Войдите в личный кабинет. Для этого введите свой ИНН и пароль, которые вы использовали при регистрации':
        'Жеке кабинетке кіріңіз. Ол үшін тіркеу кезінде пайдаланған ЖСН мен құпия сөзді енгізіңіз',
      'Перейдите в раздел "Мои полисы", в этом разделе вы найдете список всех ваших активных и завершенных договоров страхования.':
        '«Менің полисім» бөліміне өтіңіз, осы бөлімде Сіз барлық қолданыстағы және аяқталған сақтандыру шарттарының тізімін таба аласыз.',
      'Нажмите на нужный договор (полис), чтобы увидеть его подробности, включая текущий статус и сроки действия':
        'Ағымдағы мәртебесі мен жарамдылық мерзімін қоса, оның егжей-тегжейлі ақпаратын көру үшін қажетті шартты (полисті) басыңыз',
      'Если у вас возникли вопросы или проблемы с доступом, не стесняйтесь обратиться в нашу службу поддержки по номеру\n+7 700 000 3264, +7 778 870 1130':
        'Егер Сізде сұрақтар туындаса немесе қол жетімділік мәселелері болса, +7 700 000 3264, +7 778 870 1130 нөмірі бойынша біздің қолдау қызметіне хабарласыңыз',
    },
  },
  ru: {
    checkPolicy: {
      title: 'Проверка полиса',
      description:
        'Проверить наличие страхового полиса, в АО «Страховая компания «Alatau City Garant»',
      type: 'Вид страхования',
      tab1: 'По уникальному номеру',
      tab2: 'По ИИН/БИН',
      policyNumber: 'Уникальный номер полиса',
      iin: 'ИИН/БИН',
      carNumber: 'Гос. Номер ТС',
      search: 'Найти',
      result: 'Результат поиска:',
      unique: 'Уникальный номер',
      period: 'Срок действия',
      number: 'Номер ТС',
      'Также вы можете проверить полис следующим образом:':
        'Также вы можете проверить полис следующим образом:',
      'Нажмите кнопку «Проверка полиса на сайте ГКБ»':
        'Нажмите кнопку «Проверка полиса на сайте ГКБ»',
      'Далее вы будете перенаправлены на официальный сайт Государственного кредитного бюро, которое является оператором "Единой страховой базы данных" и отвечает за хранение и актуализацию информации по полисам':
        'Далее вы будете перенаправлены на официальный сайт Государственного кредитного бюро, которое является оператором "Единой страховой базы данных" и отвечает за хранение и актуализацию информации по полисам',
      'Вам будет предложено выбрать класс страхования, и ввести соответсвующие параметры для поиска. К примеру, для поиска договора (полиса) страхования, выезжающего за рубеж, вам необходимо выбрать класс страхования "Договор добровольного страхования" и ввести 12-значный уникальный номер, который указан в договоре (полисе)':
        'Вам будет предложено выбрать класс страхования, и ввести соответсвующие параметры для поиска. К примеру, для поиска договора (полиса) страхования, выезжающего за рубеж, вам необходимо выбрать класс страхования "Договор добровольного страхования" и ввести 12-значный уникальный номер, который указан в договоре (полисе)',
      'Нажмите на кнопку "Проверить полис" и получите информацию о статусе полиса':
        'Нажмите на кнопку "Проверить полис" и получите информацию о статусе полиса',
      'Проверка полиса на сайте ГКБ': 'Проверка полиса на сайте ГКБ',
      'Чат-бот Telegram от ГКБ': 'Чат-бот Telegram от ГКБ',
      'Как узнать статус вашего договора (полиса) в личном кабинете?':
        'Как узнать статус вашего договора (полиса) в личном кабинете?',
      'Войдите в личный кабинет. Для этого введите свой ИНН и пароль, которые вы использовали при регистрации':
        'Войдите в личный кабинет. Для этого введите свой ИНН и пароль, которые вы использовали при регистрации',
      'Перейдите в раздел "Мои полисы", в этом разделе вы найдете список всех ваших активных и завершенных договоров страхования.':
        'Перейдите в раздел "Мои полисы", в этом разделе вы найдете список всех ваших активных и завершенных договоров страхования.',
      'Нажмите на нужный договор (полис), чтобы увидеть его подробности, включая текущий статус и сроки действия':
        'Нажмите на нужный договор (полис), чтобы увидеть его подробности, включая текущий статус и сроки действия',
      'Если у вас возникли вопросы или проблемы с доступом, не стесняйтесь обратиться в нашу службу поддержки по номеру\n+7 700 000 3264, +7 778 870 1130':
        'Если у вас возникли вопросы или проблемы с доступом, не стесняйтесь обратиться в нашу службу поддержки по номеру\n+7 700 000 3264, +7 778 870 1130',
    },
  },
};

export default checkPolicyResources;
